import { forwardRef, useRef, useState } from 'react';
import styles from '../styles/Notes.module.css';
import ButtonOverride from '../components/buttonoverride';

const RHFButtonListSelect = forwardRef(({options = [],label,onChange,value,error,disabled},ref) => {

    const handleClick = (option) => {
        onChange(option);
      };

    return(
        <div ref={ref} className={`${error ? styles.error : null}`}>
            <strong>{label}</strong>
            <div className={styles.filterDialogBody}>
            {
                options.map((option) => (
                    <ButtonOverride disabled={disabled} type='button' key={option.id} className={`${styles.filterDialogSelectBtn} ${value === option.id ? styles.active : null}`} onClick={() => handleClick(option.id)}>
                        {option.name}
                    </ButtonOverride>
                ))
            }
            </div>
            {error && <small style={{ color: 'red' }}>{error.message}</small>}
        </div>
    )
});

export default RHFButtonListSelect;